import { useFormikContext } from 'formik';

import { Textfield } from '@src/shared/fields/text-field';
import { REMINDER_CHANNELS } from '@src/shared/types/reminder';

import type { TReminderFormValues } from './dialogs/create-or-edit-reminder/schema';

export function SubjectField() {
  const { values } = useFormikContext<TReminderFormValues>();

  if (values.notification_channel !== REMINDER_CHANNELS.email) return null;

  return (
    <Textfield
      name='subject'
      label='Subject'
      placeholder='Enter subject'
    />
  );
}
